import { Spinner } from "@chakra-ui/react";
import { useIsMenuCollapsed } from "newui/hooks/useMenuStatus";
import React, { ReactNode } from "react";

type ButtonPosition = "left" | "center" | "right";

interface FloatingButtonProps {
	children?: ReactNode;
	className?: string;
	isDisabled?: boolean;
	isLoading?: boolean;
	loadingText?: string;
	position?: ButtonPosition;
	text?: string;
	onClick: () => void;
}

const FloatingButton: React.FC<FloatingButtonProps> = ({
	className = "",
	children = null,
	isDisabled = false,
	isLoading = false,
	loadingText,
	onClick,
	position = "right",
	text = "Save",
}) => {
	const isSideBarCollapsed = useIsMenuCollapsed();

	const getLeftPosition = () => {
		if (isSideBarCollapsed) {
			return "md:left-16";
		}
		return "md:left-72";
	};

	// Tailwind classes for desktop positioning
	const positionClasses: Record<ButtonPosition, string> = {
		left: getLeftPosition(),
		center:
			"md:left-1/2 md:-translate-x-1/2 lg:left-1/2 lg:-translate-x-1/2 xl:left-1/2 xl:-translate-x-1/2",
		right: "md:right-4 lg:right-8 xl:right-12",
	};

	return (
		<div
			className={`fixed ${location} z-[1000] w-full px-4 sm:w-auto ${positionClasses[position]} ${className} `}
		>
			{children || (
				<button
					onClick={onClick}
					disabled={isDisabled}
					className="flex w-full items-center justify-center gap-2 rounded-lg bg-blue-600 px-6 py-3 font-semibold text-white shadow-lg transition-colors hover:bg-blue-700 disabled:pointer-events-none disabled:border-none disabled:bg-gray-300 disabled:text-gray-400 sm:w-auto"
				>
					{isLoading && (
						<Spinner
							size="sm"
							color="white"
						/>
					)}
					{isLoading && (loadingText ?? text)}
					{!isLoading && !isDisabled && text}
				</button>
			)}
		</div>
	);
};

export default FloatingButton;
